'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { HydrationBoundary, useQueryClient, } from '@tanstack/react-query';
import { useMemo } from 'react';
import { mergeNormalizedEntitySnapshot } from '../core/internal/normalized-entity-write.js';
export function CanonicalHydrationBoundary({ state, children, }) {
    const queryClient = useQueryClient();
    const merged = useMemo(() => mergeCanonicalEntityHydration(queryClient, state), [queryClient, state]);
    return _jsx(HydrationBoundary, { state: merged, children: children });
}
export function mergeCanonicalEntityHydration(queryClient, state) {
    let changed = false;
    const queries = state.queries.map((query) => {
        if (!isCanonicalEntityKey(query.queryKey) || !isRecord(query.state.data))
            return query;
        const previous = queryClient.getQueryData(query.queryKey);
        if (!isRecord(previous))
            return query;
        changed = true;
        return {
            ...query,
            state: {
                ...query.state,
                data: mergeNormalizedEntitySnapshot(previous, query.state.data),
            },
        };
    });
    return changed ? { ...state, queries } : state;
}
function isCanonicalEntityKey(queryKey) {
    return queryKey.length >= 3 && queryKey[0] === 'outcomes' && queryKey[1] === 'entity';
}
function isRecord(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
//# sourceMappingURL=CanonicalHydrationBoundary.js.map